<template>
    <div class="openingtimes">
        <div
            class="wizard__fields-cols wizard__fields-cols--openingtimes"
            v-for="(col, col__key) in [
                ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
            ]"
            v-bind:key="col__key"
        >
            <div v-bind:key="day" class="wizard__col wizard__col--openingtimes" v-for="day in col">
                <input
                    :id="day"
                    type="checkbox"
                    :checked="isDayChecked(day)"
                    @change="checkDay(day, $event)"
                    class="openingtimes__input"
                />

                <label :for="day" class="openingtimes__label"
                    ><span class="openingtimes__pseudo-checkbox"></span>{{ day }}</label
                >

                <div class="openingtimes__times">
                    <ul v-if="isDayChecked(day)">
                        <li
                            v-for="time in getTimes(day)"
                            v-bind:key="time.key"
                            class="openingtimes__row"
                        >
                            <div class="openingtimes__time openingtimes__time--first">
                                <app-time
                                    :value="time.from"
                                    @input="setTime(time.key, 'from', $event)"
                                ></app-time>
                            </div>
                            <div class="openingtimes__time openingtimes__time--second">
                                <app-time
                                    :value="time.until"
                                    @input="setTime(time.key, 'until', $event)"
                                ></app-time>
                            </div>
                            <a
                                v-if="!time.isFirst"
                                v-on:click.prevent="removeTime(time.key)"
                                href="#"
                                class="openingtimes__button openingtimes__button--remove"
                                >(-)</a
                            >
                            <a
                                v-if="time.isLast && time.count < 2"
                                v-on:click.prevent="addTime(day)"
                                href="#"
                                class="openingtimes__button openingtimes__button--add"
                                >(+)</a
                            >
                        </li>
                    </ul>
                    <ul v-else>
                        <li class="openingtimes__row openingtimes__row--closed">
                            geschlossen
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Time from '@/components/fields/simple/Time.vue';
import cloneDeep from 'clone-deep';
import { mapGetters, mapActions } from 'vuex';
import { toArray } from '@/helpers/utils';
import { ComplexFieldMixin } from '@/mixins/ComplexFieldMixin';

export default {
    data() {
        return {
            localVar: '18:00'
        };
    },
    components: {
        'app-time': Time
    },
    methods: {
        ...mapActions(['setProp', 'removeProp', 'addProp']),
        /* init */
        async init() {
            await this.saveDefaultValues();
        },
        /* validate */
        validate(val) {
            val = toArray(val);
            let valid = true;
            if (val.length === 0) {
                valid = true;
            }
            val.forEach((value) => {
                if (value.from == '' || value.until == '') {
                    valid = false;
                } else if (
                    !new RegExp('^[0-9][0-9]:[0-9][0-9]$').test(value.from) ||
                    !new RegExp('^[0-9][0-9]:[0-9][0-9]$').test(value.until)
                ) {
                    valid = false;
                } else if (
                    parseFloat(value.from.substring(0, 2)) +
                        parseFloat(value.from.substring(3, 5)) / 60 >=
                    parseFloat(value.until.substring(0, 2)) +
                        parseFloat(value.until.substring(3, 5)) / 60
                ) {
                    valid = false;
                }
            });
            return valid;
        },
        /* custom setters */
        async checkDay(day, e) {
            await this.componentDifferChange();
            if (e.target.checked === true) {
                await this.addProp({
                    source: this.dataSource,
                    value: { day: day, from: '08:00', until: '18:00' }
                });
            } else {
                for (const [key, value] of Object.entries(this.getProp(this.dataSource))) {
                    if (value.day === day) {
                        await this.removeProp({ source: this.dataSource + '.' + key });
                    }
                }
            }
            await this.componentDifferValidate();
        },
        async setTime(key, range, value) {
            await this.componentDifferChange();
            await this.setProp({
                source: this.dataSource + '.' + key + '.' + range,
                value: value
            });
            await this.componentDifferValidate();
        },
        async addTime(day) {
            await this.componentDifferChange();
            await this.addProp({
                source: this.dataSource,
                value: { day: day, from: '', until: '' }
            });
            await this.componentDifferValidate();
        },
        async removeTime(key) {
            await this.componentDifferChange();
            await this.removeProp({ source: this.dataSource + '.' + key });
            await this.componentDifferValidate();
        },
        async saveDefaultValues() {
            if (this.getProp(this.dataSource) === undefined) {
                await this.setProp({
                    source: this.dataSource,
                    value: {
                        0: { day: 'Montag', from: '08:00', until: '18:00' },
                        1: { day: 'Dienstag', from: '08:00', until: '18:00' },
                        2: { day: 'Mittwoch', from: '08:00', until: '18:00' },
                        3: { day: 'Donnerstag', from: '08:00', until: '18:00' },
                        4: { day: 'Freitag', from: '08:00', until: '18:00' }
                    }
                });
            }
        },
        /* custom getters */
        isDayChecked(day) {
            return toArray(this.getProp(this.dataSource)).some((i) => i.day === day);
        },
        getTimes(day) {
            let arr = [];
            Object.entries(this.getProp(this.dataSource)).forEach(([key, value]) => {
                if (value.day === day) {
                    let newVal = cloneDeep(value);
                    newVal.key = key;
                    arr.push(newVal);
                }
            });
            // add some meta information
            arr[0].isFirst = true;
            arr[arr.length - 1].isLast = true;
            arr[arr.length - 1].count = arr.length;
            return arr;
        }
    },
    computed: {
        ...mapGetters(['getProp'])
    },
    props: {
        dataSource: String
    },
    mixins: [ComplexFieldMixin]
};
</script>
